import React, { useState } from "react";
import {
  Flex,
  Text,
  Box,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  useBreakpointValue,
} from "@chakra-ui/react";
import Footer from "../components/Footer";
import styles from "./FAQPage.module.css";

const FAQPage = () => {
  // Responsive font sizes using Chakra UI's useBreakpointValue
  const faqTitleSize = useBreakpointValue({
    base: "2.5rem",
    sm: "3rem",
    md: "3.5rem",
    lg: "4rem",
    xl: "4rem",
    "2xl": "6rem",
  });

  const faqSubtitleSize = useBreakpointValue({
    base: "0.75rem",
    sm: "0.85rem",
    md: "0.9rem",
    lg: "1rem",
    xl: "1rem",
    "2xl": "1.5rem",
  });

  const accordionMaxWidth = useBreakpointValue({
    base: "95%",
    sm: "90%",
    md: "85%",
    lg: "800px",
    xl: "900px",
    "2xl": "1200px",
  });

  return (
    <Flex flexDirection="column" width="100%">
      <Flex
        flexDirection="column"
        alignItems="center"
        className={styles.headerContainer}
        width="100%"
      >
        <Text
          fontSize={faqTitleSize}
          color="#ea2e01"
          fontWeight="500"
          letterSpacing="0.25em"
          textAlign="center"
        >
          FAQ
        </Text>
        <Text
          fontSize={faqSubtitleSize}
          color="gray.500"
          fontWeight="500"
          letterSpacing="0.25em"
          mb="2rem"
          textAlign="center"
        >
          Frequently Asked Questions
        </Text>
        <Box width="100%" maxWidth={accordionMaxWidth}>
          <FAQAccordion />
        </Box>
      </Flex>
      <Flex className={styles.callOutBanner}>
        <Text className={styles.callOutText}>
          Revolutionize Construction With Us
        </Text>
        <CallOutButton />
      </Flex>
      <Footer />
    </Flex>
  );
};

export default FAQPage;

function FAQAccordion() {
  // Responsive styling for accordion items
  const questionFontSize = useBreakpointValue({
    base: "0.9rem",
    sm: "1rem",
    md: "1.1rem",
    lg: "1.2rem",
    xl: "1.3rem",
    "2xl": "1.5rem",
  });

  const answerFontSize = useBreakpointValue({
    base: "0.85rem",
    sm: "0.9rem",
    md: "0.95rem",
    lg: "1rem",
    xl: "1.1rem",
    "2xl": "1.25rem",
  });

  const faqItems = [
    {
      question: "Apa itu GFRP Rebar Kuria Bar?",
      answer: (
        <>
          <strong>GFRP (Glass Fiber Reinforced Polymer)</strong> Kuria Bar
          adalah tulangan struktural berbahan dasar serat kaca yang diikat
          dengan resin polimer, dirancang untuk menggantikan baja tulangan
          konvensional, terutama pada struktur yang membutuhkan ketahanan korosi
          dan bobot ringan.
        </>
      ),
    },
    {
      question: " Apa saja spesifikasi teknis utama Kuria Bar?",
      answer: (
        <>
          Kuria Bar memiliki spesifikasi teknis utama sebagai berikut:
          <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
            <li>
              <strong>Diameter nominal:</strong> 5 mm - 22 mm
            </li>
            <li>
              <strong>Kekuatan tarik minimum:</strong> &gt; 1000 MPa
            </li>
            <li>
              <strong>Modulus elastisitas:</strong> 50 - 60 GPa{" "}
            </li>
            <li>
              <strong>Berat jenis:</strong> ~1.9 - 2.1 g/cm
            </li>
            <li>
              <strong>Elongasi saat putus:</strong> 1.2% \u2013 2.0%
            </li>
            <li>
              <strong>Koefisien ekspansi termal:</strong> 6\u00d710\u2076
              /\u00b0C (arah longitudinal)
            </li>
            <li>
              <strong>Ketahanan korosi:</strong> Sangat tinggi, tidak
              terpengaruh oleh klorida, asam, alkali, atau lingkungan basah
            </li>
            <li>
              <strong>Konduktivitas listrik:</strong> Hampir nol (non-konduktif)
            </li>
          </ul>
        </>
      ),
    },
    {
      question: "Apakah Kuria Bar bisa dipotong atau dibengkokkan di lapangan?",
      answer: (
        <>
          Kuria Bar memiliki spesifikasi teknis utama sebagai berikut:
          <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
            <li>
              <strong>Pemotongan:</strong> Bisa dipotong dengan gergaji tangan
              bermata halus, gergaji mesin, atau alat pemotong dengan blade
              berlian (diamond blade).
            </li>
            <li>
              <strong>Pembengkokan: Tidak disarankan</strong>untuk membengkokkan
              Kuria Bar setelah diproduksi. Bila perlu bentuk khusus (U-bar,
              stirrup, hook), harus dipesan langsung dari pabrik selama proses
              manufaktur (Saat ini masih dalam tahap development).
            </li>
          </ul>
        </>
      ),
    },
    {
      question:
        "Apakah dalam mendesain struktur menggunakan GFRP Kuria Bar merujuk standar SNI?",
      answer: (
        <>
          <strong>Ya</strong>
          <br />
          Dalam perancangan struktur beton bertulang menggunakan GFRP seperti
          Kuria Bar, prinsip umumnya mengikuti standar nasional yang berlaku,
          khususnya:
          <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
            <li>
              <strong>SNI 2847:2019</strong> – Persyaratan Beton Struktural
              untuk Bangunan Gedung (mengacu sebagian pada ACI 318)
            </li>
            <li>
              <strong>SNI 8790:2019</strong> – Pedoman Umum Penggunaan Material
              FRP untuk Penguatan Struktur Beton
            </li>
            <li>
              <strong>SNI 8974:2021</strong> – Spesifikasi Pelaksanaan
              Penggunaan Batang Tulangan dengan Serat Berpolimer (ACI 440.5M-08,
              IDT)
            </li>
            <li>
              <strong>SNI 8975:2021</strong> – Spesifikasi material batang serat
              karbon dan serat gelas berpolimer untuk penulangan beton (ACI
              440.6M-08, IDT).
            </li>
          </ul>
          <br />
          Namun karena GFRP rebar masih termasuk teknologi baru di Indonesia,
          rujukan teknis utamanya masih menggunakan adaptasi standar
          internasional seperti:
          <ul style={{ paddingLeft: "20px", marginTop: "10px" }}>
            <li>
              <strong>ACI 440.1R</strong> (Guide for the Design and Construction
              of Structural Concrete Reinforced with FRP Bars)
            </li>
            <li>
              <strong>ASTM D7957</strong> (Spesifikasi material untuk GFRP bar)
            </li>
          </ul>
        </>
      ),
    },
    {
      question:
        "Bagaimana cara yang disarankan untuk mengantisipasi lendutan/kuria bar tidak lurus?",
      answer:
        "Seperti halnya tulangan baja dalam pemasangannya sebaiknya tetap menggunakan beton tahu sebagai selimut beton. Kuria bar ini cukup kaku untuk diameter 8 mm ke atas.",
    },
    {
      question: "Bagaimana cara menyambung Kuria Bar?",
      answer:
        "Penyambungan tulangan menggunakan panjang penyaluran (Ld) dengan tulangan saling overlapping. Untuk aturan panjang penyalurannya dapat dilihat pada SNI 8970:2021 atau ACI 440R-15.",
    },
    {
      question: "Apakah GFRP rebar dan FRP rebar itu sama?",
      answer: (
        <>
          Ya, <strong>GFRP rebar</strong> (Glass Fiber Reinforced Polymer)
          adalah salah satu jenis dari <strong>FRP rebar</strong> (Fiber
          Reinforced Polymer) yang lebih umum. Semua GFRP rebar adalah FRP
          rebar, tetapi tidak semua FRP rebar adalah GFRP rebar.
          <br />
          FRP rebar adalah istilah umum yang mencakup berbagai jenis tulangan
          komposit. Jenis FRP rebar yang paling umum adalah yang menggunakan
          serat kaca, yaitu GFRP rebar. Ada juga jenis lain yang menggunakan
          serat karbon (CFRP rebar) atau serat aramid (AFRP rebar). Produk kami,{" "}
          <strong>Kuria Bar</strong>, adalah tulangan komposit yang terbuat dari
          serat kaca, menjadikannya GFRP rebar.
        </>
      ),
    },
  ];

  return (
    <Flex direction="column" width="100%" gap={{ base: "2vh", md: "3vh" }}>
      {faqItems.map((item, index) => (
        <Accordion
          key={index}
          allowToggle
          width="100%"
          borderWidth="1px"
          borderRadius={{ base: "16px", md: "20px", lg: "24px" }}
          boxShadow="sm"
          mb={{ base: "2", md: "3" }}
        >
          <AccordionItem border="none">
            <h2>
              <AccordionButton
                _expanded={{
                  bg: "gray.50",
                  color: "#ea2e01",
                  borderRadius: {
                    base: "16px 16px 0 0",
                    md: "20px 20px 0 0",
                    lg: "24px 24px 0 0",
                  },
                }}
                _hover={{ bg: "gray.50" }}
                borderRadius={{ base: "16px", md: "20px", lg: "24px" }}
                py={{ base: 3, md: 4 }}
                px={{ base: 3, md: 4 }}
              >
                <Box
                  flex="1"
                  textAlign="left"
                  fontWeight="500"
                  fontSize={questionFontSize}
                >
                  {item.question}
                </Box>
                <AccordionIcon />
              </AccordionButton>
            </h2>
            <AccordionPanel
              pb={{ base: 3, md: 4 }}
              pt={{ base: 2, md: 3 }}
              px={{ base: 3, md: 4 }}
              bg="gray.50"
              borderRadius={{
                base: "0 0 16px 16px",
                md: "0 0 20px 20px",
                lg: "0 0 24px 24px",
              }}
              fontSize={answerFontSize}
            >
              {item.answer}
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      ))}
    </Flex>
  );
}

function CallOutButton() {
  // Responsive button styling
  const buttonPadding = useBreakpointValue({
    base: "8px 20px",
    sm: "10px 24px",
    md: "12px 30px",
    lg: "12px 30px",
    xl: "14px 36px",
    "2xl": "16px 42px",
  });

  const buttonFontSize = useBreakpointValue({
    base: "16px",
    sm: "18px",
    md: "20px",
    lg: "24px",
    xl: "28px",
    "2xl": "32px",
  });

  return (
    <Box
      as="button"
      className={styles.callOutButton}
      transition="all 0.2s cubic-bezier(.08,.52,.52,1)"
      _hover={{ bg: "#ebedf0" }}
      _active={{
        bg: "#dddfe2",
        transform: "scale(0.98)",
        borderColor: "#bec3c9",
      }}
      _focus={{
        boxShadow:
          "0 0 1px 2px rgba(88, 144, 255, .75), 0 1px 1px rgba(0, 0, 0, .15)",
      }}
      padding={buttonPadding}
      fontSize={buttonFontSize}
    >
      <a href="/contact">JOIN OUR TEAM</a>
    </Box>
  );
}
